import React, { useState, useEffect } from "react"
import { loadAppConfig } from '@chr/online-shared-microsite-core';
import logoModule from '@chr/autoStyle/dist/img/CHR/CHR_LogoTM_Horz_2C_RGB.png';

export const ProfileConfirmationNotFound = () => {
  const [ onlineOneUrl, setOnlineOneUrl ] = useState('');

  useEffect(() => {
    async function getUrl() {
      const { online1Uri } = await loadAppConfig() as AppConfig;
      setOnlineOneUrl(online1Uri);
    }

    getUrl();
  }, []);

  return (
    <div id="notfound">
      <div className="container main margin-top-50">
        <div>
          <img
            className="chr-logo"
            src={logoModule}
            style={{maxWidth: '200px'}}
            alt="CHR-logo" />
        </div>
        <div className="margin-top-20">
          <h1 style={{color: 'red'}} >
            <span className="ns-icon ns-error"/>
            Oops... Looks like there is a problem
          </h1>
        </div>

        <p>
          We are unable to complete the email verification process for your Navisphere profile.
        </p>
        <p>
          The 7-day time window for completing the process may have passed or there may be another issue.
        </p>
        <p>
          The next time you log in to Navisphere please follow the prompts to confirm your profile again.
        </p>

        <div className="margin-top-20">
          <a
            href={onlineOneUrl}
            className="btn btn-primary"
            data-testid="goto-btn"
          >
            Go to navisphere.chrobinson.com
          </a>
        </div>
        <div className="margin-top-20">
          <p>
            <b>Contact your C.H. Robinson representitive if this problem continues.</b>
          </p>
        </div>
      </div>
    </div>
  );
}

